module.exports = __webpack_public_path__ + "img/59.1ae07e63.jpg";